import { render, staticRenderFns } from "./birthdayBanner.vue?vue&type=template&id=4e9c8627&scoped=true"
import script from "./birthdayBanner.vue?vue&type=script&lang=js"
export * from "./birthdayBanner.vue?vue&type=script&lang=js"
import style0 from "./birthdayBanner.vue?vue&type=style&index=0&id=4e9c8627&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9c8627",
  null
  
)

export default component.exports